module.exports = __webpack_public_path__ + "img/4-2.f84c3c6d.png";